export const removeCharacters = function (val) {
  if(!val) return
  let formated = val
  formated = formated.trim()
  formated = formated.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  formated = formated.replace(/[^\w\s]/g, '')
  
  return formated
}
